import React,{useState,useEffect} from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Telegramimg from '../../../assets/Tuzilma/Tekegramm.svg'
import InstagramImg from '../../../assets/Tuzilma/Instagramm.svg'
import FacebookImg from '../../../assets/Tuzilma/Facebook.svg'
import Techimg from '../../../assets/Tuzilma/tech.png'
import './Teacher.css'
import { Link } from 'react-router-dom'

import axios from 'axios'
import {useParams} from 'react-router-dom'
function Teacher() {
  const settings = {
    className: "center",
    infinite: true,
    centerPadding: "10px",
    slidesToShow: 2,
    swipeToSlide: true,
    autoplay: true,
      speed: 3000,
      autoplaySpeed: 2000,
      cssEase: "linear",
    
  };
    
    const {id} =useParams();
    const[teach,setTeach]=useState([])
    const loadTeach=async()=>{
      const res=await axios.get('https://afternoon-reaches-98033.herokuapp.com/api/teacher')
      setTeach(res.data)
    }
 useEffect(()=>{
   loadTeach()
 },[])
  return (
    <div className='Teacher'>
        {
            teach.filter(card=>card.id===parseInt(id))
            .map((card,index)=>(
                
                <div key={card.id} className='wrapper'>
        <div className=' Teacher__imogo'>
            <img src={Techimg} alt="" />
            <div className='social'>
                    <img src={FacebookImg} alt=""   className='teachicon' />
                    <img src={InstagramImg} alt=""  className='teachicon' />
                    <img src={Telegramimg} alt=""   className='teachicon'/>
                  </div>
        </div>
        <div className='Teacher__descriptions'>
            <h1>{card.firstname}  {card.lastname} {card.middlename}</h1>
            <p>O‘zbekiston Respublikasining 1991 yil 18 noyabrdagi 407-XII-sonli «O‘zbekiston Respublikasining Davlat bayrog‘i to‘g‘risida»gi Qonuni bilan tasdiqlangan.
           <br/>
            O‘zbekiston Respublikasining Davlat bayrog‘i — bayroqning butun uzunligi bo‘ylab o‘tgan to‘q moviy rang, oq rang va to‘q yashil rangli uchta endan tarkib topgan to‘g‘ri to‘rtburchak shaklidagi matodir.
            <br/>
            O‘zbekiston Respublikasi Davlat bayrog‘ining uzunligi 250 santimetrga, kengligi 125 santimetrga teng. Moviy rang, oq rang va yashil rangli enlarning kengligi bir xil. Har bir en 40 santimetrga tengdir. O‘zbekiston Respublikasi Davlat bayrog‘ining o‘rtasidagi oq rangli enning chetlaridan kengligi 2,5 santimetrga teng qizil hoshiyalar o‘tkazilgan.
            <br/>
            O‘zbekiston Respublikasi Davlat bayrog‘ining yuqori qismidagi moviy rangli enning yuz tomoni va orqa tomonida dastaga yaqin joyida oq rangli yangi oy va uning yonida o‘n ikkita oq rangdagi besh qirrali yulduz tasvirlangan.
            </p>
        </div>
        </div>  
            )
            )
}

     <div className='carousell'>
     <div className='name'>
          <div className="line"></div>
          <p className='titlee'>Boshqa xodimlar</p></div>
          
        <Slider {...settings}>
          {
       teach.map((item,index)=>{
          return(
            <div className='Teachers__box' key={item.id}>
            <div className='teacher' >
              <img src={Techimg}  className='techimg' alt="" />
              <div className='teacher__infoss'>
                 <div className='fullname'>{item.firstname}  {item.lastname}<br/>{item.middlename}</div>
                 <div className='position'>{item.position}</div>
                 <div className='description'>Oliy toifali matematika o’qituvchisi. 2004-yilda O’zMUning “Amaliy matematika” fakultetini tamomlagan. 2006-yilda SamDUning matematikani... 
                 <Link to={`/teacher/${item.id}`}><span className='batafsil'> Batafsil o’qish</span></Link>
                 </div>
              </div>
            </div></div>
          )
        })
     }</Slider>
    </div>
      
     </div>
    
  )
}

export default Teacher